import { render, staticRenderFns } from "./custom-sale.vue?vue&type=template&id=f48640a6"
import script from "./custom-sale.vue?vue&type=script&lang=js"
export * from "./custom-sale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NumberPad: require('/home/ubuntu/complete-nuxt-js/components/number-pad.vue').default})
